import React, { useMemo } from 'react';
import { useProfile } from '../../../../../shared/hooks/Profile';
import { Redirect } from 'react-router-dom';

const redirection = {'ADE':"/Usuarios/AdministracionExpatriados","ADM":"/Partes",
"FIS":"/Partes","USR":"/Partes","RAR":"/Partes","FAC":"/Partes","RHH":"/Partes"}

export const WrapperLogin = (props)=>{
   
    const {currentUser} = props;

    const EsRolExpatriados = useMemo(()=>
    currentUser.administraExpatriados === true || currentUser.administraExpatriadosLocal === true || currentUser.consultaExpatriados === true
    ,[currentUser])
    
    return EsRolExpatriados ? <Redirect to={redirection['ADE']}/> : <Redirect to={redirection[currentUser.perfil]}/>
    // return (<Redirect to={redirection[profile]} />)
}